module.exports = __webpack_public_path__ + "img/hj-bg1.1269110b.jpg";